import { React } from '../../../includes/exports/react';
import { Spin } from 'antd';

import './styles.scss';

const Loader = props => <Spin className="payce-loader" {...props} />;

export default Loader;
